import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RetiredService {

  constructor(private http: HttpClient) { }

  postContactInfoData(payload: any): Observable<any> {

    let obs = this.http.post(`${environment.memberappapiendpoint.replace('acepmemberappapi', 'chapterportalapi')}UpdateContact`, payload);
    return obs;
  }




}
